
import React from "react";
import { Link } from "react-router-dom";
import {
  BriefcaseBusiness,
  FileCheck,
  CalendarClock,
  IndianRupee,
  ArrowUpRight,
} from "lucide-react";

import "./TrainerWorking.css";

const workSections = [
  {
    title: "Available jobs",
    description: "Relevant training opportunities",
    icon: BriefcaseBusiness,
    link: "/trainer/available-jobs",
    linkText: "Explore jobs",
  },
  {
    title: "My applications",
    description: "Track application status",
    icon: FileCheck,
    link: "/trainer/my-applications",
    linkText: "View applications",
  },
  {
    title: "Upcoming work",
    description: "Confirmed training assignments",
    icon: CalendarClock,
    link: "/trainer/my-applications",
    linkText: "View assignments",
  },
  {
    title: "Compensation",
    description: "Salary or training fees, when available",
    icon: IndianRupee,
    link: "/trainer/my-applications",
    linkText: "View details",
  },
];

export default function TrainerWorking() {
  return (
    <main className="trainer-working-page">
      <header className="trainer-working-header">
        <div className="trainer-working-main-icon">
          <BriefcaseBusiness size={27} />
        </div>

        <div className="trainer-working-heading">
          <h1>Trainer Work Opportunities</h1>
          <p>
            Find training assignments and manage your applications.
          </p>
        </div>
      </header>

      <section
        className="trainer-working-grid"
        aria-label="Trainer work sections"
      >
        {workSections.map((item) => {
          const Icon = item.icon;

          return (
            <Link
              to={item.link}
              className="trainer-working-card"
              key={item.title}
            >
              <div className="trainer-working-card-icon">
                <Icon size={21} />
              </div>

              <div className="trainer-working-card-content">
                <h2>{item.title}</h2>
                <p>{item.description}</p>
              </div>

              <div className="trainer-working-card-link">
                <span>{item.linkText}</span>
                <ArrowUpRight size={17} />
              </div>
            </Link>
          );
        })}
      </section>
    </main>
  );
}
